import * as moment from 'moment';

import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601, propExists } from '../../../../../../../../../../utils';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-edit-recurring-customer-membership-schedule-unfreeze',
  templateUrl: './edit-recurring-customer-membership-schedule-unfreeze.component.html',
  styleUrls: ['./edit-recurring-customer-membership-schedule-unfreeze.component.css']
})
export class EditRecurringCustomerMembershipScheduleUnfreezeComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public unfreezeDate: string = null;

  // The number of days from now (positive = future, negative = past) of the
  // selected effective date.
  public unfreezeDaysFromNow: number = null;

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfigService: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    // Reload the org config, in case the membership freeze reason policy has changed.
    this.orgConfigService.loadOrganizationConfig();
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public updateUnfreezeDaysFromNow() {
    if (!propExists(this.unfreezeDate)) {
      this.unfreezeDaysFromNow = null;
    } else {
      this.unfreezeDaysFromNow = moment(this.unfreezeDate).diff(moment(), 'days');
    }
    this.errorMessage = '';
  }

  private handleSave() {
    const orgConfig = this.orgConfigService.getOrganizationConfig();
    if (this.unfreezeDate === null) {
      this.errorMessage = 'Please select a date for the unfreeze to take effect.';
      return;
    }

    this.loadingEvent.emit(true);

    this.errorMessage = '';

    this.customerService
      .scheduleMembershipUnfreeze(
        this.membership,
        this.unfreezeDate
      )
      .then(() => {
        this.savedCallback('Membership successfully scheduled to be unfrozen.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to unfreeze this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
